import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId, getUserData } from "../../Redux/UserSlice";
import {
  backendApi,
  callPlayBot,
  FinishApi,
  LiveCallApi,
  ThankYouApi,
} from "../../services/service";
import * as Scroll from "react-scroll";
import LoaderComp from "../../LoaderComp";

var scroll = Scroll.scroller;
var Element = Scroll.Element;

const InformationPage = ({ setPage, languageContent }) => {
  const dispatch = useDispatch();
  const call_id = useSelector(getCallId);
  const user = useSelector(getUserData);
  const [showButtons, setShowButtons] = useState(false);
  const [liveCallResponse, setLiveCallResponse] = useState(false);
  const [checked, setChecked] = useState(false);
  const template_information = async () => {
    await callPlayBot(call_id, "information")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          setShowButtons(true);
          if (user?.flow_type && user?.flow_type?.toLowerCase() === "hdfc") {
            setPage("callDisconnected");
          }
        }
        setLiveCallResponse(true);
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };

  useEffect(() => {
    if (user?.flow_type && user?.flow_type?.toLowerCase() === "hdfc") {
      let delay = 0,
        duration = 0;
      if (
        user.language.toLowerCase() === "en" ||
        user.language.toLowerCase() === "english"
      ) {
        delay = 45000;
        duration =
          user.product && user.product.toLowerCase() === "ulip"
            ? 200000
            : 150000;
      } else {
        delay = 35000;
        duration =
          user.product && user.product.toLowerCase() === "ulip"
            ? 220000
            : 170000;
      }
      scroll.scrollTo("myScrollToElement", {
        duration: duration,
        ignoreCancelEvents: false,
        smooth: true,
        delay: delay,
      });
    }
    submitApi("information_page", "open");
    // template_information();
    const id = setTimeout(() => {
      setShowButtons(true);
    }, 7000);
    return () => {
      clearTimeout(id);
      Scroll.animateScroll.scrollToTop();
    };
  }, []);

  const handleAgreeInformation = async () => {
    if (!checked) {
    } else {
      await backendApi(call_id, "important_points", "agree")
        .then((res) => {
          if (res.data) {
            if (user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" && user?.vrm_or_rbb_flag && (user?.vrm_or_rbb_flag.toLowerCase() === "rbb" || user?.vrm_or_rbb_flag.toLowerCase() === "vrm")) {
              setPage("hdfcScripts");
            } else {
              setPage("video");
            }
            // setPage("video");
          }
        })
        .catch((e) => {
          console.log(e.message);
          setPage("sorryPage");
        });
    }
  };

  const handleDisagreeInformation = async () => {
    await ThankYouApi(call_id)
      .then((res) => console.log(res.data))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await FinishApi(call_id)
      .then((res) => setPage("thankYou"))
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
  };
  useEffect(() => {
    user.product?.toLowerCase() == "term" && setChecked(true);
  }, [user.product]);
  return liveCallResponse ? (
    <>
      <div className="heading">
        <p>{languageContent.information_page.info_title}</p>
      </div>
      {user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" ? (
        <div
          style={{
            textAlign: "justify",
          }}
          id="information_page_height"
        >
          {languageContent.information_page.common_points_start.map((item) => {
            return item.type === "text" ? (
              <p style={{ marginBottom: "0.6rem" }}>{item.content}</p>
            ) : item.type === "embeddedHtml" &&
              (user.language.toLowerCase() === "hin" ||
                user.language.toLowerCase() === "hindi") ? (
              <p style={{ marginBottom: "0.6rem" }}>
                {/* हम पॉलिसी जारी करने के दिनांक से 7 कार्य दिवसों के अंदर आपको
                पॉलिसी दस्तावेज भेज देंगे. यदि आपने ई-पॉलिसी का चयन किया है तो
                आपको अपने ई-इंश्योरेंस अकाउंट में डिमटीरियलाइज़्ड पॉलिसी दस्तावेज
                मिल जाएगा’’. आदित्य बिरला सन लाइफ आपको माय इंश्योरेंस के रूप में
                जानी जानेवाली ऑनलाइन सेवा प्रदान करती है जो संपर्क विवरण अपडेशन
                (अद्यतनीकरण), प्रीमियम भुगतान, फंड मूल्य विवरण जांचने जैसी
                सुविधाएँ हासिल करने में मदद करता है. अपना रजिस्ट्रेशन करने के
                लिए कृपया हमारी वेबसाइट{" "}
                <a href="https://www.adityabirlacapital.com" target="_blank">
                  www.adityabirlacapital.com
                </a>{" "}
                पर लॉग ऑन करें. विस्तृत जानकारी के लिए कृपया पॉलिसी दस्तावेज
                पढें. आप हमारे टोल फ्री कस्टमर सर्विस नंबर{" "}
                <a href="tel:18002707000" style={{ textDecoration: "none" }}>
                  {" "}
                  1800 270 7000{" "}
                </a>{" "}
                पर भी कॉल कर सकते हैं. */}
              </p>
            ) : (
              <p style={{ marginBottom: "0.6rem" }}>
                {/* We will Dispatch your policy document with-in 7 working days
                from the policy issuance date. If you have opted for an
                e-policy, you will receive the dematerialised policy document in
                your e-insurance account. Aditya Birla Sun Life provides you
                with an online service known as My Insurance which helps you
                avail facilities like contact detail updation, premium payments,
                check fund value details etc. Kindly log onto our website{" "}
                <a href="www.adityabirlacapital.com">
                  www.adityabirlacapital.com
                </a>{" "}
                to register yourself. For detailed information, kindly go
                through the policy document .You can also call our toll free
                customer service number{" "}
                <a href="tel:18002707000" style={{ textDecoration: "none" }}>
                  {" "}
                  1800 270 7000{" "}
                </a> */}
              </p>
            );
          })}
          {/* {user?.product?.toLowerCase() !== "par" &&
          user?.product?.toLowerCase() !== "non par"
            ? languageContent.information_page.common_points_end.map((item) => (
                <p style={{ marginBottom: "0.6rem" }}>{item.content}</p>
              ))
            : null} */}
          <Element name="myScrollToElement"></Element>
        </div>
      ) : (
        <>
          {(user.language.toLowerCase() === "en" ||
            user.language.toLowerCase() === "english") && (
            <>
              <ul
                style={{
                  textAlign: "justify",
                  marginLeft: "-0.9rem",
                  fontFamily: "PF Handbook Pro",
                }}
              >
                <li>
                  I am aware that purchase of this policy is not essential for
                  getting any kind of bonus, payout of any life insurance
                  policy, gifts, loans or overdrafts.
                </li>
                <li>
                  Life Insurance is a stand alone product and is neither a fixed
                  deposit nor loan, nor is it linked to any other baking
                  products.
                </li>
                <li>
                  We will dispatch your policy document with-in 7 working days
                  from the policy issuance date. If you have opted for an
                  e-policy, you will receive the dematerialized policy document
                  in your e-insurance account.
                </li>
                <li>
                  Aditya Birla Sun Life provides you with an online service
                  known as My Insurance, which helps you avail facilities like
                  contact detail updation, premium payments, check fund value
                  details etc.
                </li>
                <li>
                  Kindly log onto our website&nbsp;
                  <br />
                  <a
                    href="https://www.adityabirlasunlifeinsurance.com"
                    target="_blank"
                  >
                    www.adityabirlasunlifeinsurance.com
                  </a>
                  &nbsp; to register yourself.
                </li>
                <li>
                  For detailed information kindly go through the policy
                  document.
                </li>
                <li>
                  You can also call our Toll free customer service number&nbsp;
                  <a href="tel:18002707000" style={{ textDecoration: "none" }}>
                    1800 270 7000
                  </a>
                </li>
                <li>
                  On receipt of policy document, we request you to go through
                  the information submitted in application form. If you are not
                  satisfied with the terms of the policy or require any
                  alteration, you have an option to get back to us within 15
                  days (30 in case of electronic policy/ distance marketing
                  policy) from the date of receipt of the policy document OR the
                  delivery date of the email confirming the credit of the
                  Insurance policy by the Insurance Repository to the eIA
                  whichever is earlier. We request you to check your email/sms
                  for the same.
                </li>
              </ul>
              <Element name="myScrollToElement"></Element>
            </>
          )}
          {(user.language.toLowerCase() === "hin" ||
            user.language.toLowerCase() === "hindi") && (
            <>
              <ul
                style={{
                  textAlign: "justify",
                  // marginLeft: "-0.9rem",
                  fontFamily: "PF Handbook Pro",
                }}
              >
                <li>
                  हूम पॉलिसी जारी करने के दिनांक से ७ कामकाजी दिनों के अंदर आपका
                  पॉलिसी दस्तावेज भेज देंगे. यदि आपने ई-पॉलिसी का विकल्प चुना है
                  तो आपको पॉलिसी के दस्तावेज ई-इंश्योरेंस अकाउंट में
                  डिमटीरियलाइज्ड रूप में प्राप्त होंगे आदित्य बिरला सनलाइफ माय
                  इंश्योरेंस जैसी ऑनलाइन सुविधा प्रदान करता है जो आपको संपर्क
                  विवरण का अद्युतनीकरण करने, प्रीमियम भुगतान, फंड मूल्य के विवरण
                  जाँचने इ. जैसी सुविधाएँ पाने में मदद करती है.
                </li>
                <li>
                  खुद को रजिस्टर करवाने के लिए कृपया हमारी वेबसाइट{" "}
                  <a href="www.adityabirlasunlifeinsurance.com">
                    www.adityabirlasunlifeinsurance.com
                  </a>{" "}
                  पर लॉग ऑन करें विस्तृत जानकारी के लिए कृपया पॉलिसी दस्तावेज
                  पढें. आप हमारेँ टोल फ्री कस्टमर सर्विस नंबर{" "}
                  <a href="tel:18002707000">18002707000</a> पर भी कॉल कर सकते
                  हैं.
                </li>
                <li>
                  मैं यह जानता/जानती हूँ कि किसी भी प्रकार का बोनस, जीवन बीमा
                  पॉलिसी का भुगतान, उपहार/ऋण/ओवरड्राफ्ट प्राप्त करने के लिए यह
                  पॉलिसी का खरीदना अत्यावश्यक नहीं है. जीवन बीमा एक एकल उत्पाद
                  है और यह न तो कोई फिक्स्ड डिपॉजिट / स्थाई जमा है, न कोई ऋण है,
                  और न ही यह किसी अन्य बैंकिंग उत्पाद से सम्भुदित है.
                </li>
                <li>
                  पॉलिसी दस्तावेज प्राप्त होने पर, हम आपसे अनुरोध करते हैं कि आप
                  आवेदन पत्र में जमा की गई जानकारी को देखें। यदि आप पॉलिसी की
                  शर्तों से संतुष्ट नहीं हैं या किसी भी तरह का बदलाव चाहते हैं
                  तो आप पॉलिसी दस्तावेज प्राप्त होने की तिथि से 15 दिनों के भीतर
                  या बीमा रिपोजिटरी द्वारा ईआईए को बीमा पॉलिसी के क्रेडिट की
                  पुष्टि करने वाले ईमेल की डिलीवरी तिथि, जो भी पहले हो , हमसे
                  संपर्क कर सकते हैं (इलेक्ट्रॉनिक पॉलिसी/डिस्टेंस मार्केटिंग
                  पालिसी के मामले में 30 दिन). हम आपसे इसके लिए अपने ईमेल/एसएमएस
                  की जांच करने का अनुरोध करते हैं।
                </li>
              </ul>

              <Element name="myScrollToElement"></Element>
            </>
          )}
        </>
      )}

      {user.product && user.product?.toLowerCase() === "ulip" ? 
        user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" ?  (
          languageContent.information_page.hdfc_ulip_points.map((item) => {
            return (
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  textAlign: "left",
                }}
              >
                {item.type.toLowerCase() == "checkbox" && (
                  <input
                    type="checkbox"
                    checked={checked}
                    id=""
                    onChange={() => {
                      setChecked(!checked);
                    }}
                  />
                )}
                <p
                  onClick={() => setChecked(!checked)}
                  style={
                    item?.type?.toLowerCase() == "checkbox"
                      ? { fontWeight: "bolder", margin: 0, textAlign: "left" }
                      : {}
                  }
                  className={`${item.type.toLowerCase() == "checkbox" ? "" : ""}`}
                >
                  {item.content}
                </p>
              </div>
            );
          })
        ) : (
          languageContent.information_page.ulip_points.map((item) => {
            return (
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  textAlign: "left",
                }}
              >
                {item.type.toLowerCase() == "checkbox" && (
                  <input
                    type="checkbox"
                    checked={checked}
                    id=""
                    onChange={() => {
                      setChecked(!checked);
                    }}
                  />
                )}
                <p
                  onClick={() => setChecked(!checked)}
                  style={
                    item?.type?.toLowerCase() == "checkbox"
                      ? { fontWeight: "bolder", margin: 0, textAlign: "left" }
                      : {}
                  }
                  className={`${item.type.toLowerCase() == "checkbox" ? "" : ""}`}
                >
                  {item.content}
                </p>
              </div>
            );
          })
        )
      
      : (user.product && user.product?.toLowerCase() === "par") ||
        (user.product && user.product?.toLowerCase() === "non par") ?
        user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" ?  (
        languageContent.information_page.hdfc_par_and_non_par_points.map((item) => {
          return (
            <div
              className=""
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              {item.type.toLowerCase() == "checkbox" && (
                <input
                  type="checkbox"
                  checked={checked}
                  id=""
                  onChange={() => {
                    setChecked(!checked);
                  }}
                />
              )}
              <p
                onClick={() => setChecked(!checked)}
                style={
                  item?.type?.toLowerCase() == "checkbox"
                    ? { fontWeight: "bolder", margin: 0, textAlign: "left" }
                    : {}
                }
                className={`${item.type.toLowerCase() == "checkbox" ? "" : ""}`}
              >
                {item.content}
              </p>
            </div>
          );
        })
      ) : (
        languageContent.information_page.par_and_non_par_points.map((item) => {
          return (
            <div
              className=""
              style={{
                display: "flex",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              {item.type.toLowerCase() == "checkbox" && (
                <input
                  type="checkbox"
                  checked={checked}
                  id=""
                  onChange={() => {
                    setChecked(!checked);
                  }}
                />
              )}
              <p
                onClick={() => setChecked(!checked)}
                style={
                  item?.type?.toLowerCase() == "checkbox"
                    ? { fontWeight: "bolder", margin: 0, textAlign: "left" }
                    : {}
                }
                className={`${item.type.toLowerCase() == "checkbox" ? "" : ""}`}
              >
                {item.content}
              </p>
            </div>
          );
        })
      ) 
      : (
        <div
          className=""
          style={{
            display: "flex",
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            id=""
            onChange={() => {
              setChecked(!checked);
            }}
          />
          <p
            onClick={() => setChecked(!checked)}
            style={{ fontWeight: "bolder", margin: 0, textAlign: "left" }}
          >
            I hereby confirm that, I have declared all the Pre-existing policy
            details availed by me in the past on the application form while
            applying for this policy.
          </p>
        </div>
      )}
      {showButtons && (
        <div className="floatingButton">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button className="backButton" onClick={handleDisagreeInformation}>
              {languageContent.buttons.disagree}
            </button>
            <button
              className={`${checked ? "myButton" : "disabled-button"} `}
              onClick={handleAgreeInformation}
            >
              {languageContent.buttons.next}
            </button>
          </div>
          {/* {(user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc') ? null : (<img
            src="./hand.png"
            className="submitHandIcon"
            alt=""
            style={{ height: "3rem", width: "3rem" }}
          />)} */}
        </div>
      )}
    </>
  ) : (
    <LoaderComp />
  );
};

export default InformationPage;
